import React, { useEffect, useState } from "react";
import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { fetchOtpSmsLogs } from "../actions";
import { injectIntl } from "react-intl";

const styles = (theme) => ({
  root: {
    ...theme.typography.body1,
    fontSize: theme.typography.pxToRem(20),
  },
  title: {
    ...theme.typography.h5,
    marginBottom: theme.spacing(2),
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  headCell: {
    textAlign: "left",
    borderBottom: "1px solid #ddd",
    fontSize: theme.typography.pxToRem(18),
  },
  bodyCell: {
    borderBottom: "1px solid #f0f0f0",
    fontSize: theme.typography.pxToRem(17),
  },
});

const OtpListPage = ({ classes, history, intl }) => {
  const [smsLogs, setSmsLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    const loadSmsLogs = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const data = await fetchOtpSmsLogs();
        if (active) {
          setSmsLogs(data);
        }
      } catch (err) {
        if (active) {
          setError(err?.message || "Failed to load SMS logs");
        }
      } finally {
        if (active) {
          setIsLoading(false);
        }
      }
    };

    loadSmsLogs();

    return () => {
      active = false;
    };
  }, []);

  if (isLoading) {
    return <div className={classes.root}>Loading SMS logs...</div>;
  }

  if (error) {
    return <div className={classes.root}>Error loading SMS logs: {error}</div>;
  }

  return (
    <div className={classes.root}>
      <h2 className={classes.title}>OTP SMS Logs</h2>
      {smsLogs.length === 0 ? (
        <div>No SMS logs found.</div>
      ) : (
        <table className={`MuiTable-root ${classes.table}`}>
          <thead>
            <tr>
              <th className={classes.headCell}>{intl.formatMessage({ id: "otp.list.table.phone" })}</th>
              <th className={classes.headCell}>{intl.formatMessage({ id: "otp.list.table.InsuranceNo" })}</th>
              <th className={classes.headCell}>{intl.formatMessage({ id: "otp.list.table.ClaimCode" })}</th>
              <th className={classes.headCell}>{intl.formatMessage({ id: "otp.list.table.OTPCode" })}</th>
              {/* Message, Status and Sent columns hidden */}
              <th className={classes.headCell}>{intl.formatMessage({ id: "otp.list.table.CreatedOn" })}</th>
            </tr>
          </thead>
          <tbody>
            {smsLogs.map((log) => (
              <tr key={log.id}>
                <td className={classes.bodyCell}>{log.phone || "-"}</td>
                <td className={classes.bodyCell}>{log.insureeChfId || "-"}</td>
                <td className={classes.bodyCell}>{log.claimCode || "-"}</td>
                <td className={classes.bodyCell}>{log.otpCode || "-"}</td>
                {/* Message, Status and Sent cells hidden */}
                <td className={classes.bodyCell}>{log.createdOn || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default injectIntl(withStyles(styles)(OtpListPage));
